import type { AppAction, Dispatch, ThunkAction } from '../../types/app.types';

export type MenuState = {
  readonly menuIsOpen: boolean;
  currPath: string;
  view: string;
  viewHistory: Array<string>;
};
export type UpdateMenu = {
  type: 'menu/UPDATE';
  path: string;
};
type UpdateView = {
  type: 'menu/UPDATE_VIEW';
  view: string;
};
type GoToPreviousView = {
  type: 'menu/GO_TO_PREVIOUS_VIEW';
};
type Open = {
  type: 'menu/OPEN';
};
type Close = {
  type: 'menu/CLOSE';
};
export type MenuAction = Open | Close | UpdateMenu | UpdateView | GoToPreviousView;
const initialState: MenuState = {
  menuIsOpen: false,
  currPath: '',
  view: '',
  viewHistory: [],
};

export function updateMenu(path: string): UpdateMenu {
  return {
    type: 'menu/UPDATE',
    path,
  };
}

export function updateView(view: string): UpdateView {
  return {
    type: 'menu/UPDATE_VIEW',
    view,
  };
}

export function goToPreviousView(): GoToPreviousView {
  return {
    type: 'menu/GO_TO_PREVIOUS_VIEW',
  };
}

export function openMenu(): Open {
  return {
    type: 'menu/OPEN',
  };
}

export function closeMenu(): Close {
  return {
    type: 'menu/CLOSE',
  };
}

export function closeAndNavigate(url: string): ThunkAction<Close> {
  return function (dispatch: Dispatch, _, { history }): Close {
    history.push(url);
    return dispatch({
      type: 'menu/CLOSE',
    });
  };
}

export default function menuReducer(state: MenuState = initialState, action: AppAction): MenuState {
  switch (action.type) {
    case 'menu/UPDATE':
      return { ...state, currPath: action.path };

    case 'menu/UPDATE_VIEW':
      return { ...state, view: action.view, viewHistory: [...state.viewHistory, state.view] };

    case 'menu/GO_TO_PREVIOUS_VIEW': {
      const lastView = state.viewHistory[state.viewHistory.length - 1];
      const newViewHistory = state.viewHistory.slice(0, state.viewHistory.length - 2);
      return { ...state, view: lastView, viewHistory: newViewHistory };
    }

    case 'menu/OPEN':
      return { ...state, menuIsOpen: true };

    /**
     * action types that will close the menu if it is open:
     */
    case 'menu/CLOSE':
      return { ...state, menuIsOpen: false };

    default:
      return state;
  }
}
